import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { NAV } from "@/content";

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="site-header">
      <div className="wrap header-inner">
        <Link to="/" className="logo" data-testid="logo-home">
          <span className="logo-text">
            <b>Cerebral Diagnostics</b>
            <span>Brain Imaging</span>
          </span>
        </Link>
        <nav className="nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"} data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <Link to="/contact" className="btn btn-primary header-cta" data-testid="nav-contact">Contact</Link>
        <button className="burger" onClick={() => setOpen(!open)} data-testid="burger-btn" aria-label="Menu">
          {open ? "Close" : "Menu"}
        </button>
      </div>
      {open && (
        <div className="mobile-nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"} onClick={() => setOpen(false)}>{n.label}</NavLink>
          ))}
          <NavLink to="/contact" onClick={() => setOpen(false)}>Contact</NavLink>
        </div>
      )}
    </header>
  );
}
